export default {
    TOP: 'top',
    TOP_3: 'top3',
    TOP_10: 'top10',
    TOP_20: 'top20',
    TOP_100: 'top100',
    REST: 'rest',
};
